import React, { useState } from 'react';

import styled from '@emotion/styled';

import StatusCell from '../../../../components/Badge/StatusCell';
import { FormSubmitBtn } from '../../../../components/Button/FormSubmitButton';
import { Modal } from '../../../../components/Modal/Modal';
import KycInformationModal from '../../../../components/Modal/ModalActions/KycInformationModal/KycInformationModal';
import { useAppSelector } from '../../../../redux/store';

const KycInformation = () => {
  const [showModal, setShowModal] = useState(false);
  const { businessInfo } = useAppSelector((state) => state.businessInfoData);

  return (
    <>
      <Box>
        <BoxTextArea>
          <BoxBoldText>KYC Information</BoxBoldText>
          <StatusArea>
            <BoxText>KYC Status:</BoxText>
            <StatusCell
              data={{ status: businessInfo?.kycStatus ?? '' }}
              statusKey='status'
              hasDot
            />
          </StatusArea>
          {['Declined'].includes(businessInfo?.kycStatus ?? '') && (
            <GreyText>
              Your KYC verification was declined. Refill the KYC form to
              resubmit
            </GreyText>
          )}
          {['Required', 'Rejected'].includes(businessInfo?.kycStatus ?? '') && (
            <GreyText>
              Complete your KYC to gain full access to your dashboard.
            </GreyText>
          )}
        </BoxTextArea>
        {['Declined', 'Rejected'].includes(businessInfo?.kycStatus ?? '') && (
          <FormSubmitBtn
            onClick={() => setShowModal(true)}
            type='button'
            className='fit'
          >
            Resubmit
          </FormSubmitBtn>
        )}
        {['Required'].includes(businessInfo?.kycStatus ?? '') && (
          <FormSubmitBtn
            onClick={() => setShowModal(true)}
            type='button'
            className='fit'
          >
            Submit
          </FormSubmitBtn>
        )}
        <Modal showModal={showModal} setShowModal={setShowModal}>
          <KycInformationModal className='pink' />
        </Modal>
      </Box>
    </>
  );
};

export default KycInformation;

const Box = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 28px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: #fff;
`;

const BoxTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const BoxBoldText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const BoxText = styled.div`
  gap: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  font-weight: 500;
`;

const GreyText = styled.div`
  background: ${({ theme }) => theme.palette.lightNeutralGray};
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const StatusArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
